import { PortalLinkedItemType } from "@/Common/Models/Portal/Enums/PortalLinkedItemType";
import { SharedItemPriority } from "@/Common/Models/Portal/SharedItem/SharedItemPriority";
import { IPortalLinkedItemModel } from "@/Common/Models/Portal/UI/IPortalLinkedItemModel";
import * as LocalPatientOperations from "@/Common/Operations/operations.patient.local";
import { ExportableFile } from "@/ExportableFile/Models/ExportableFile";
import { PortalPopupModel } from "@/Portal/Models/PortalPopupModel";
import { BaseSendMedicalNoteItemToPortalPopupStrategy } from "@/Portal/Services/Strategies/BaseSendMedicalNoteItemToPortalPopupStrategy";

class SendObstetricalFileFormStrategy extends BaseSendMedicalNoteItemToPortalPopupStrategy {
    public readonly isSignatureRequired = false;
    public readonly disclaimer = "";

    public get signableFile(): ExportableFile {
        return this.portalPopupModel.exportableFilePreview;
    }

    public get itemCheckOperation(): LocalPatientOperations.MedicalNote {
        return LocalPatientOperations.MedicalNote.MedicalNoteForm_OnPortalFormMessageChecked;
    }

    constructor(
        portalPopupModel: PortalPopupModel,
        signatureAcceptedCallback: () => void,
        signatureRejectedCallback: () => void = null
    ) {
        super(
            PortalLinkedItemType.ObstetricalFile,
            LocalPatientOperations.MedicalNote.MedicalNoteForm_PortalStatusRevoke,
            LocalPatientOperations.MedicalNote.MedicalNoteForm_ClosePortalPopup,
            portalPopupModel,
            signatureAcceptedCallback,
            signatureRejectedCallback
        );
    }

    public onSendToPortalClick(subject: string, newMessage: string, includeDocument: boolean, _portalItemModel?: IPortalLinkedItemModel, priority?: SharedItemPriority, canPatientReplyWithMessage?: boolean): void {
        sessionStore.dispatch(
            LocalPatientOperations.MedicalNote.MedicalNoteForm_SendToPortal,
            {
                subject: subject,
                messageText: newMessage,
                includeDocument: includeDocument,
                exportableFile: this.signableFile,
                formType: PortalLinkedItemType.ObstetricalFile,
                priority: priority,
                canPatientReplyWithMessage: canPatientReplyWithMessage
            }
        );
    }
}

export { SendObstetricalFileFormStrategy };
